/**
 * Generic AutomatedTexting Settings
 */

import { clone, isEmpty } from 'lodash'

import { SETTINGS_DIALOG_MODE } from '@/store/settings/util'

export const AUTOMATED_TEXTING_EMPTY = {
  allow_automated_text: false,
  automated_text_interval: 0,
  automated_text_interval_unit: 'days',
  automated_text_message: '',
}

export const AutomatedTextState = {
  automatedTextSettings: {},
  automatedTextSettingsShowDialog: false,
  automatedTextSettingsEditMode: SETTINGS_DIALOG_MODE.detail,
}

export const AutomatedTextActions = {
  setupAutomatedTextSettings: async ({ commit }, automatedTextSettings) => {
    if (isEmpty(automatedTextSettings)) commit('setAutomatedTextSettings', clone(AUTOMATED_TEXTING_EMPTY))
    else commit('setAutomatedTextSettings', automatedTextSettings)
  },
}

export const AutomatedTextMutations = {
  setAutomatedTextSettings: (state, payload) => { state.automatedTextSettings = payload },
  setAutomatedTextSettingsDialogShow: (state, payload) => { state.automatedTextSettingsShowDialog = payload },
}

export const AutomatedTextGetters = {
  automatedTextSettings: state => state.automatedTextSettings,
  automatedTextSettingsConfigured: state => state.automatedTextSettings?.allow_automated_text,
  isAutomatedTextSettingsDialogShow: state => state.automatedTextSettingsShowDialog,
}
